import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { attachmentResourceType } from "./attachmentResourceConsts";

export const attachmentIdentifierStruct = createIdentifierStruct(
  attachmentResourceType
);
